import { sectorConstants, alertConstants} from '../_constants'
import { sectorService, companyService} from '../_services'
import { alertActions } from './'

export const sectorActions = {
  addSector,
  getSector,
  getSectorByPage,
  getSectorById,
  updateSector,
  deleteSector,
  updateFilters,
  clearAllMessages,
  getSectorChartData,
  getCompanyBySectorIndustyChartData,
  linkChartData,
  linkCompanyData
}
function linkChartData(node)
{
  return dispatch => {
    dispatch(request(node))
  }
  function request(node) { return { type: sectorConstants.LINK_CHART_REQUEST,node } }
}

function linkCompanyData(node)
{
  return dispatch => {
    dispatch(request(node))
    companyService.getCompanyById(node.data.companyId)
      .then(
        company => {
          console.log(company)
          dispatch(success(company))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(node) { return { type: sectorConstants.LINK_COMPANY_REQUEST,node } }
  function success(company) { return { type: sectorConstants.LINK_COMPANY_SUCCESS, company } }
  function failure(error) { return { type: sectorConstants.LINK_COMPANY_FAILURE, error } }
}

function clearAllMessages()
{
  return dispatch => {
    dispatch(request())
  }
  function request() { return { type: alertConstants.CLEAR } }
}

function addSector(sector) {
  return dispatch => {
    dispatch(request(sector))

    sectorService.addSector(sector)
      .then(
        sector => {
          console.log(sector)
          dispatch(success(sector))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(sector) { return { type: sectorConstants.ADD_REQUEST, sector } }
  function success(sector) { return { type: sectorConstants.ADD_SUCCESS, sector } }
  function failure(error) { return { type: sectorConstants.ADD_FAILURE, error } }
}
function getSector() {
  return dispatch => {
    dispatch(request())

    sectorService.getSector()
      .then(
        sector => {
          console.log(sector)
          dispatch(success(sector))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(sector) { return { type: sectorConstants.GETALL_REQUEST, sector } }
  function success(sector) { return { type: sectorConstants.GETALL_SUCCESS, sector } }
  function failure(error) { return { type: sectorConstants.GETALL_FAILURE, error } }
}

function getSectorChartData() {
  return dispatch => {
    dispatch(request())

    sectorService.getSectorChartData()
      .then(
        sector => {
          console.log(sector)
          dispatch(success(sector))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(sector) { return { type: sectorConstants.GET_CHART_DATA_REQUEST, sector } }
  function success(sector) { return { type: sectorConstants.GET_CHART_DATA_SUCCESS, sector } }
  function failure(error) { return { type: sectorConstants.GET_CHART_DATA_FAILURE, error } }
}
function getCompanyBySectorIndustyChartData(sectorId,industryId) {
  return dispatch => {
    dispatch(request())
    sectorService.getCompanyBySectorIndustyChartData(sectorId,industryId)
      .then(
        sector => {
          console.log(sector)
          dispatch(success(sector))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(sector) { return { type: sectorConstants.GET_SI_CHART_DATA_REQUEST, sector } }
  function success(sector) { return { type: sectorConstants.GET_SI_CHART_DATA_SUCCESS, sector } }
  function failure(error) { return { type: sectorConstants.GET_SI_CHART_DATA_FAILURE, error } }
}

function getSectorByPage(start,pageSize,search,sortBy) {
  return dispatch => {
    dispatch(request({start,pageSize,search,sortBy}))
    sectorService.getSectorByPage(start,pageSize,search, sortBy)
      .then(
        sector => {
          console.log('sector' + sector)
          if(sector.data)
            dispatch(success(sector))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(sector) { return { type: sectorConstants.GETALL_PAGE_REQUEST, sector } }
  function success(sector) { return { type: sectorConstants.GETALL_PAGE_SUCCESS, sector } }
  function failure(error) { return { type: sectorConstants.GETALL_PAGE_FAILURE, error } }
}
function getSectorById(id) {
  return dispatch => {
    dispatch(request())

    sectorService.getSectorById(id)
      .then(
        sector => {
          console.log(sector)
          dispatch(success(sector))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(sector) { return { type: sectorConstants.GETBYID_REQUEST, sector } }
  function success(sector) { return { type: sectorConstants.GETBYID_SUCCESS, sector } }
  function failure(error) { return { type: sectorConstants.GETBYID_FAILURE, error } }
}
function updateSector(sector,id) {
  return dispatch => {
    dispatch(request(sector))
    sectorService.updateSector(sector,id)
      .then(
        sector => {
          console.log('sector' + sector)
          if(sector.data.message)
            dispatch(success(sector.data))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(sector) { return { type: sectorConstants.UPDATE_REQUEST, sector } }
  function success(sector) { return { type: sectorConstants.UPDATE_SUCCESS, sector } }
  function failure(error) { return { type: sectorConstants.UPDATE_FAILURE, error } }
}
function deleteSector(id,userId) {
  return dispatch => {
    dispatch(request(id,userId))
    sectorService.deleteSector(id,userId)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
          dispatch(getSectorByPage(0,20,''))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: sectorConstants.DELETE_REQUEST, response } }
  function success(response) { return { type: sectorConstants.DELETE_SUCCESS, response } }
  function failure(error) { return { type: sectorConstants.DELETE_FAILURE, error } }
}

function updateFilters(sectorId) {
  return dispatch => {
    dispatch(request(sectorId))

    sectorService.updateFilters(sectorId)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: sectorConstants.UPDATE_FILTER_REQUEST, response } }
  function success(response) { return { type: sectorConstants.UPDATE_FILTER_SUCCESS, response } }
  function failure(error) { return { type: sectorConstants.UPDATE_FILTER_FAILURE, error } }
}
